export default {"src":"/_next/static/media/grid.e8fe63de.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};